import AssessmentServer from "../../api/assessment";
import capacity from "@/api/assessment/capacity";

/**
 * 通过属于某个部门的所有数据中心的IT负载的总和，判断容量系数
 * @param sysroomInfo
 * @param deptId
 */
export const getCapacityRatioOper = async function (sysroomInfo, deptId) {
    let capacityRatio = 0;
    let totalItLoad = getDeptItload(sysroomInfo, deptId);

    await AssessmentServer.capacity.byItload(totalItLoad).then(res => {
        capacityRatio = res.data;
    });
    return Number(capacityRatio);
};

export const getDeptItload = function (sysroomInfo, deptId) {
    let totalItLoad = 0;
    sysroomInfo.forEach(e => {
        if (e.dept_id == deptId) {
            totalItLoad += e.itload;
        }
    });
    return totalItLoad.toFixed(2);
}

export const ASSESSMENT_PERMISSION = "menu.assessment.oper";


